import { FC } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/SidebarGroups/SidebarGroupsItemChevron.styl'

type SidebarGroupsItemChevronProps = {
  color: 'satin' | 'success'
}

export const SidebarGroupsItemChevron: FC<SidebarGroupsItemChevronProps> = (props) => {
  return (
    <div className={ cn(styles.chevron, styles[props.color]) }>
      <svg xmlns='http://www.w3.org/2000/svg' width='36' height='23' viewBox='0 0 36 23'>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M18.218 13.586L31.324.48l4.69 4.69-17.779 17.778-3.11-3.11-.018.016-15.12-15.12 4.69-4.69 13.541 13.542z'
        />
      </svg>
    </div>
  )
}
